import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import logo from "../../../../assets/images/logo.png";
import { DesktopMainMenu, MaterialUISwitch, MenuLink ,Div} from "../styles";
import { toggleTheme } from '../../../../Redux/switchTheme'
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';

const DesktopMenu = (props) => {
  const currentTheme = useSelector((state) => state.LDTheme.value)
  const dispatch = useDispatch();
  const handleClick = () => {
   
    navigator.clipboard.writeText("Contract has been copied!");
    toast.success("Contract has been copied!");
  }
  return (
    <Div>
    <DesktopMainMenu maxWidth="xl">
      <MenuLink href="/" p="0px">
        <img src={logo} width="" height='' alt="Logo" />
        
      </MenuLink>
      <div style={{display:"flex",alignItems:"center"}}>
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink>)}
        <button onClick={handleClick} value="fddfhdjhjkfdhkjhf" style={{padding:'10px 10px',borderRadius:'10px',backgroundColor:'#fff',color:'blue',border:'1px solid #fff',fontSize:'17px'}}>Copy Contract</button>
        
        {/* <FormControlLabel
          control={
            <MaterialUISwitch 
              sx={{ m: 1 }} 
              checked={currentTheme}
            />
          }
          onClick={() => dispatch(toggleTheme())}
        /> */}
        <ToastContainer />
      </div>
    </DesktopMainMenu>
    </Div>
  );
};

export default DesktopMenu;
